import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { isEmpty, isLoaded, useFirestoreConnect } from "react-redux-firebase";
import { Link } from "react-router-dom";
import LoadingIndicator from "../../../components/common/LoadingIndicator";
import NewItemForm from "../../../components/forms/menu/NewItemForm";
import { ADMIN_MENU_PATH } from "../../../constants/paths";

const NewProductPage = ({ match }) => {
  const [restaurantId, setRestaurantId] = useState("nothing");
  const uid = useSelector(({ firebase }) => firebase.auth.uid);

  useFirestoreConnect([
    { collection: "restaurants", where: [["user_id", "==", uid]] },
  ]);

  const restaurant = useSelector(({ firestore }) =>
    firestore.ordered.restaurants ? firestore.ordered.restaurants[0] : {}
  );

  useEffect(() => {
    if (isLoaded(restaurant) && !isEmpty(restaurant))
      setRestaurantId(restaurant.id);
  }, [restaurant]);

  if (!isLoaded(restaurant)) return <LoadingIndicator></LoadingIndicator>;

  return (
    <div className="px-16 py-8 text-gray-900">
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b">Nuevo producto</p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          <div className="menu">
            <NewItemForm
              restaurantId={restaurantId}
              sectionId={match.params.section_id}
            ></NewItemForm>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProductPage;
